import { Box, Skeleton, Typography } from '@mui/material';
import React from 'react';
import HelpCenterLink from '../atoms/HelpCenterLink';
import { useMe } from '../config/api/queries';
import { capitalizeFirstLetter } from '../utils';
import RootineButton from '../atoms/RootineButton';

const NameSkeleton = () => (
  <Skeleton
    variant="text"
    sx={{
      fontSize: { xs: '24px', md: '48px' },
      pb: { xs: 2, sm: 6 },
      width: 300,
      borderRadius: { xs: 2, sm: 5 },
    }}
  />
);

export const Welcome = ({
  scrollToFormulaTable,
}: {
  scrollToFormulaTable?: () => void;
}): JSX.Element => {
  const me = useMe();

  if (me.isLoading) {
    return <NameSkeleton />;
  }

  if (!me.data) {
    return <></>;
  }

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      sx={{ mb: { xs: 0, md: 4 } }}
    >
      {me.data.first_name ? (
        <Typography
          align="left"
          color="primary"
          variant="bold"
          component="h1"
          sx={{ fontSize: { xs: 32, md: 48 } }}
        >
          {`Hello, ${capitalizeFirstLetter(me.data?.first_name)}!`}
        </Typography>
      ) : (
        <NameSkeleton />
      )}
      <Box
        display="flex"
        flexDirection="row"
        gap={2}
        sx={{ mt: { xs: 2, md: 0 }, mb: { xs: 2, md: 0 } }}
      >
        <RootineButton
          label="View precision formula"
          size="small"
          variation="primary"
          hideIcon
          onClick={scrollToFormulaTable}
        />
        <HelpCenterLink />
      </Box>
    </Box>
  );
};
